// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_k4-0";
export var fileCarousel = "_k4-2";
export var removeFileButton = "_k4-1";